import { DescriptionOutlined } from '@mui/icons-material';
import { Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import { reportFileName } from '@/pages/Candidate/view/tabs/OneOffChecksTab/RequestOneOff/FormContent/adapters';
import { rowLinkSx } from './rowLink';

const FileName = styled('span')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: 11,
  lineHeight: 1.3,
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

const ReportLink = ({ href, originalName }: { href: string; originalName?: string | null }) => {
  const generated = reportFileName(href);
  const original = originalName?.trim();
  const showOriginal = Boolean(original && original !== generated);

  return (
    <span
      style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start', maxWidth: 220, minWidth: 0 }}
    >
      <Link href={href} rel="noopener noreferrer" sx={{ ...rowLinkSx, maxWidth: '100%' }} target="_blank" title={href}>
        <DescriptionOutlined />
        View Report
      </Link>
      {showOriginal ? <FileName title={original}>Original: {original}</FileName> : null}
      <FileName title={generated}>{showOriginal ? `Generated: ${generated}` : generated}</FileName>
    </span>
  );
};

export default ReportLink;
